import { render, staticRenderFns } from "./LevelControlForm.vue?vue&type=template&id=38c36f8c&"
import script from "./LevelControlForm.vue?vue&type=script&lang=js&"
export * from "./LevelControlForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentVOP/build/VOPWebApp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38c36f8c')) {
      api.createRecord('38c36f8c', component.options)
    } else {
      api.reload('38c36f8c', component.options)
    }
    module.hot.accept("./LevelControlForm.vue?vue&type=template&id=38c36f8c&", function () {
      api.rerender('38c36f8c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/routing/global/LevelControlForm.vue"
export default component.exports